import React, { useState } from 'react';
import './AddChargeComponent.css';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import ENDPOINTS from '../../../Constants/ApiEndpoints';
import axios from 'axios';

const AddChargeComponent = ({ onClose, onSubmit, patient,refreshInvoices,refreshCharges, refreshAmounts,refreshInvoiceSummary }) => {

    console.warn(patient);
    const [loading, setLoading] = useState(false);
    const chargeOptions = [
        '',
        'Registration',
        'Scan',
        'Room',
        'Services',
        'Surgery Charges',
        'Doctor',
        'Custom Services',
        'Other',
        'Packages',
    ];

    // State: array of charge forms
    const [chargeForms, setChargeForms] = useState([
        { chargeType: '', formValues: {} },
    ]);

    const totalCost = chargeForms.reduce((total, form) => {
        if (!form.chargeType) return total;

        const fv = form.formValues;

        if (form.chargeType === 'Services') {
            // Calculate unitCost * units if both present
            const unitCost = Number(fv.unitCost) || 0;
            const units = Number(fv.units) || 0;
            return total + unitCost * units;
        }

        // Otherwise use amount if present
        const amount = Number(fv.amount) || 0;
        return total + amount;
    }, 0);

    // --- copied dropdown options (replace with your original) ---
    const [doctorList] = useState(['Dr. Viswanath', 'Dr. Sushma']);
    const [registrationCharges] = useState(['Initial', 'Follow-up']);
    const [roomTypes, setRoomTypes] = useState([]);
    const [unitTypes] = useState(['Hr', 'unit', 'visit', 'day', 'no unit']);
    const [customServices] = useState(['Stretcher', 'Ambulance']);
    const [surgeryTypes] = useState(['Appendectomy', 'Bypass']);
    const [packages] = useState(['Health Checkup', 'Maternity']);

    React.useEffect(() => {
        Promise.all([
            axios.get(ENDPOINTS.GET_ALL_ROOM_TYPES).catch(() => ({ data: [] })),
            axios.get(ENDPOINTS.GET_ALL_ROOMS).catch(() => ({ data: [] })),
            axios.get(ENDPOINTS.GET_ALL_CHARGE_CONFIGS).catch(() => ({ data: [] }))
        ]).then(([roomTypesRes, roomsRes, configsRes]) => {
            const fetchedTypes = new Set();
            if (Array.isArray(roomTypesRes.data)) {
                roomTypesRes.data
                    .filter(rt => rt.status === 'Active' || !rt.status)
                    .forEach(rt => { if (rt.name) fetchedTypes.add(rt.name.toUpperCase()); });
            }
            if (Array.isArray(roomsRes.data)) {
                roomsRes.data.forEach(r => { if (r.roomType) fetchedTypes.add(r.roomType.toUpperCase()); });
            }
            if (Array.isArray(configsRes.data)) {
                configsRes.data.forEach(c => { if (c.roomType) fetchedTypes.add(c.roomType.toUpperCase()); });
            }
            setRoomTypes(Array.from(fetchedTypes));
        });
    }, []);

    const roomChargeTypeOptions = {
        'GENERAL WARD': ['BED CHARGES', 'NURSING FEES', 'DUTY DOCTOR FEES'],
        ICU: ['BED CHARGES', 'ICU CHARGES', 'NURSING FEES', 'MONITORING FEES', 'CONSULTATION FEES'],
        'NON-AC ROOM': ['ROOM CHARGES', 'NURSING FEES', 'DOCTOR CHARGES'],
        'EMERGENCY WARD': ['BED CHARGES', 'NURSING FEES', 'CONSULTATION FEES', 'MONITORING FEES', 'EMERGENCY CHARGES'],
    };

    const commonServices = [
        'OXYGEN',
        'MONITOR',
        'INFUSION PUMP',
        'NEBULISATION',
        'EMERGENCY',
        'BLOOD TRANSFUSION',
        'BLOOD SUGAR STRIP',
        'NIV MASK',
        'FOLEYS CATHETERISATION',
        'INJECTION CHARGES',
        'INJECTION IN DRIP',
        'I.V CANNULA PACK',
        'ASCITIC TAP',
        'INTUBATION',
        'ALPHA BED',
        'DVT',
        'VENTILATOR CHARGES',
        'ICD',
        'SYRINGE PUMP',
        'PHYSIOTHERY',
    ];

    const serviceTypeOptionsByRoom = {
        'GENERAL WARD': [...commonServices],
        ICU: [...commonServices],
        'NON-AC ROOM': [...commonServices],
        'EMERGENCY WARD': [...commonServices],
    };

    const doctorChargeTypeOptionsByRoom = serviceTypeOptionsByRoom;

    const serviceUnitCosts = {
        OXYGEN: 200,
        MONITOR: 400,
        'INFUSION PUMP': 500,
        NEBULISATION: 150,
        EMERGENCY: 800,
        'BLOOD TRANSFUSION': 1200,
        'BLOOD SUGAR STRIP': 50,
        'NIV MASK': 300,
        'FOLEYS CATHETERISATION': 350,
        'INJECTION CHARGES': 100,
        'INJECTION IN DRIP': 120,
        'I.V CANNULA PACK': 180,
        'ASCITIC TAP': 900,
        INTUBATION: 1000,
        'ALPHA BED': 1500,
        DVT: 1100,
        'VENTILATOR CHARGES': 2000,
        ICD: 950,
        'SYRINGE PUMP': 600,
        PHYSIOTHERY: 500,
    };



    // Update chargeType or formValues for a specific form index
    const handleChargeTypeChange = (index, value) => {
        setChargeForms((prev) => {
            const newForms = [...prev];
            newForms[index].chargeType = value;
            newForms[index].formValues = {}; // reset fields when charge type changes
            return newForms;
        });
    };

    const handleInputChange = (index, name, value) => {
        setChargeForms((prev) => {
            const newForms = [...prev];
            if (name === 'serviceType' && serviceUnitCosts[value]) {
                newForms[index].formValues = {
                    ...newForms[index].formValues,
                    [name]: value,
                    unitCost: serviceUnitCosts[value],
                };
            } else {
                newForms[index].formValues = {
                    ...newForms[index].formValues,
                    [name]: value,
                };
            }
            return newForms;
        });
    };

    // Render your dynamic form fields per charge form index (use chargeForms[index])
    const renderFormFields = (chargeType, formValues, index) => {
        const renderCommonField = (label, name, type = 'text', props = {}) => (
            <div key={name + index} style={{ marginBottom: '8px' }}>
                <label>{label}</label>
                <input
                    type={type}
                    name={name}
                    value={formValues[name] || ''}
                    onChange={(e) => handleInputChange(index, name, e.target.value)}
                    {...props}
                />
            </div>
        );

        switch (chargeType) {
            case 'Room':
                return (
                    <div key={'room-' + index}>
                        <div>
                            <label>Room Type</label>
                            <select
                                name="roomType"
                                value={formValues.roomType || ''}
                                onChange={(e) => handleInputChange(index, 'roomType', e.target.value)}
                            >
                                <option value="">Select Room Type</option>
                                {roomTypes.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formValues.roomType && (
                            <>
                                <div>
                                    <label>Charge Type</label>
                                    <select
                                        name="roomChargeType"
                                        value={formValues.roomChargeType || ''}
                                        onChange={(e) => handleInputChange(index, 'roomChargeType', e.target.value)}
                                    >
                                        <option value="">Select Charge Type</option>
                                        {(roomChargeTypeOptions[formValues.roomType] || []).map((type, i) => (
                                            <option key={i} value={type}>
                                                {type}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {renderCommonField('Amount', 'amount', 'number')}
                                {renderCommonField('Description', 'description')}
                            </>
                        )}
                    </div>
                );

            case 'Registration':
                return (
                    <div key={'registration-' + index}>
                        <div>
                            <label>Charge</label>
                            <select
                                name="registrationCharge"
                                value={formValues.registrationCharge || ''}
                                onChange={(e) => handleInputChange(index, 'registrationCharge', e.target.value)}
                            >
                                <option value="">Select Charge</option>
                                {registrationCharges.map((charge, i) => (
                                    <option key={i} value={charge}>
                                        {charge}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {renderCommonField('Amount', 'amount', 'number')}
                    </div>
                );

            case 'Scan':
                return (
                    <div key={'scan-' + index}>
                        {renderCommonField('Description', 'description')}
                        {renderCommonField('Amount', 'amount', 'number')}
                    </div>
                );

            case 'Services':
                return (
                    <div key={'services-' + index}>
                        <div>
                            <label>Room Type</label>
                            <select
                                name="roomType"
                                value={formValues.roomType || ''}
                                onChange={(e) => handleInputChange(index, 'roomType', e.target.value)}
                            >
                                <option value="">Select Room Type</option>
                                {roomTypes.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formValues.roomType && (
                            <>
                                <div>
                                    <label>Service Type</label>
                                    <select
                                        name="serviceType"
                                        value={formValues.serviceType || ''}
                                        onChange={(e) => handleInputChange(index, 'serviceType', e.target.value)}
                                    >
                                        <option value="">Select Service Type</option>
                                        {(serviceTypeOptionsByRoom[formValues.roomType] || []).map((type, i) => (
                                            <option key={i} value={type}>
                                                {type}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {formValues.serviceType && (
                                    <>
                                        {renderCommonField('Unit Cost', 'unitCost', 'number')}
                                        {renderCommonField('No. of Units', 'units', 'number')}
                                        <div>
                                            <label>Type of Unit</label>
                                            <select
                                                name="unitType"
                                                value={formValues.unitType || ''}
                                                onChange={(e) => handleInputChange(index, 'unitType', e.target.value)}
                                            >
                                                <option value="">Select Unit Type</option>
                                                {unitTypes.map((type, i) => (
                                                    <option key={i} value={type}>
                                                        {type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label>Doctor Name</label>
                                            <select
                                                name="doctorName"
                                                value={formValues.doctorName || ''}
                                                onChange={(e) => handleInputChange(index, 'doctorName', e.target.value)}
                                            >
                                                <option value="">Select Doctor</option>
                                                {doctorList.map((doc, i) => (
                                                    <option key={i} value={doc}>
                                                        {doc}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                );

            case 'Surgery Charges':
                return (
                    <div key={'surgery-' + index}>
                        <div>
                            <label>Doctor Name</label>
                            <select
                                name="doctorName"
                                value={formValues.doctorName || ''}
                                onChange={(e) => handleInputChange(index, 'doctorName', e.target.value)}
                            >
                                <option value="">Select Doctor</option>
                                {doctorList.map((doc, i) => (
                                    <option key={i} value={doc}>
                                        {doc}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Charge</label>
                            <select
                                name="surgeryChargeType"
                                value={formValues.surgeryChargeType || ''}
                                onChange={(e) => handleInputChange(index, 'surgeryChargeType', e.target.value)}
                            >
                                <option value="">Select Surgery Type</option>
                                {surgeryTypes.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {renderCommonField('Amount', 'amount', 'number')}
                        {renderCommonField('Description', 'description')}
                    </div>
                );

            case 'Doctor':
                return (
                    <div key={'doctor-' + index}>
                        <div>
                            <label>Doctor Name</label>
                            <select
                                name="doctorName"
                                value={formValues.doctorName || ''}
                                onChange={(e) => handleInputChange(index, 'doctorName', e.target.value)}
                            >
                                <option value="">Select Doctor</option>
                                {doctorList.map((doc, i) => (
                                    <option key={i} value={doc}>
                                        {doc}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Room Type</label>
                            <select
                                name="roomType"
                                value={formValues.roomType || ''}
                                onChange={(e) => handleInputChange(index, 'roomType', e.target.value)}
                            >
                                <option value="">Select Room Type</option>
                                {roomTypes.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Charge Type</label>
                            <select
                                name="doctorChargeType"
                                value={formValues.doctorChargeType || ''}
                                onChange={(e) => handleInputChange(index, 'doctorChargeType', e.target.value)}
                            >
                                <option value="">Select Charge Type</option>
                                {(doctorChargeTypeOptionsByRoom[formValues.roomType] || []).map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {renderCommonField('Amount', 'amount', 'number')}
                        {renderCommonField('Description', 'description')}
                    </div>
                );

            case 'Custom Services':
                return (
                    <div key={'custom-' + index}>
                        <div>
                            <label>Custom Service</label>
                            <select
                                name="customService"
                                value={formValues.customService || ''}
                                onChange={(e) => handleInputChange(index, 'customService', e.target.value)}
                            >
                                <option value="">Select Custom Service</option>
                                {customServices.map((service, i) => (
                                    <option key={i} value={service}>
                                        {service}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {renderCommonField('Amount', 'amount', 'number')}
                        {renderCommonField('Description', 'description')}
                    </div>
                );

            case 'Other':
                return (
                    <div key={'other-' + index}>
                        {renderCommonField('Description', 'description')}
                        {renderCommonField('Amount', 'amount', 'number')}
                    </div>
                );

            case 'Packages':
                return (
                    <div key={'packages-' + index}>
                        <div>
                            <label>Package</label>
                            <select
                                name="packageName"
                                value={formValues.packageName || ''}
                                onChange={(e) => handleInputChange(index, 'packageName', e.target.value)}
                            >
                                <option value="">Select Package</option>
                                {packages.map((pkg, i) => (
                                    <option key={i} value={pkg}>
                                        {pkg}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {renderCommonField('Amount', 'amount', 'number')}
                        {renderCommonField('Description', 'description')}
                    </div>
                );

            default:
                return null;
        }
    };


    // Submit: filter out incomplete charges (e.g. no chargeType or amount)
    const handleSubmit = async () => {
        if (!chargeForms.length) {
            toast.error('Please add at least one charge.');
            return;
        }

        setLoading(true);

        try {
            const payloadList = chargeForms.map((form) => {
                const { formValues, chargeType } = form;

                const unitCost = parseFloat(formValues.unitCost) || parseFloat(formValues.amount);
                const usage = parseFloat(formValues.units) || 1;
                const directAmount = parseFloat(formValues.amount);

                return {
                    chargeName:
                        formValues.chargeName ||
                        formValues.serviceType ||
                        formValues.registrationCharge ||
                        formValues.roomChargeType ||
                        formValues.doctorChargeType ||
                        formValues.customService ||
                        formValues.packageName ||
                        formValues.surgeryChargeType ||
                        chargeType || 'Unknown Charge',

                    unitCost,
                    usage,
                    status: formValues.status || 'ACTIVE',
                    description: formValues.description || '',
                    amount: isNaN(directAmount) ? unitCost * usage : directAmount,
                    chargeType: chargeType?.toUpperCase(),
                    admissionId: patient.admissionId,
                };
            });


            // 👇 Send array instead of individual calls
            await axios.post(ENDPOINTS.ADD_CHARGES, payloadList);

            refreshInvoices(patient.admissionId);
            refreshCharges();
            refreshAmounts(patient.admissionId);
            refreshInvoiceSummary(patient.admissionId);

            toast.success('✅ Charges added successfully!');
            onSubmit?.();
            onClose();
        } catch (error) {
            console.error('Charge submission failed:', error);
            toast.error('❌ Failed to save charges.');
        } finally {
            setLoading(false);
        }
    };





    return (
        <div className="payment-popup-overlay">
            <div className="payment-popup">
                <h3>Add Charges</h3>

                {chargeForms.map((form, idx) => (
                    <div className="charge-card animated-card" key={idx}>
                        {chargeForms.length > 1 && (
                            <button
                                onClick={() => setChargeForms(prev => prev.filter((_, i) => i !== idx))}
                                className="remove-bttn"
                                title="Remove Charge"
                            >
                                <FaMinusCircle />
                            </button>
                        )}

                        <div className="form-group">
                            <label>Charge Type</label>
                            <select
                                value={form.chargeType}
                                onChange={(e) => handleChargeTypeChange(idx, e.target.value)}
                            >
                                {chargeOptions.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type || 'Select Charge Type'}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            {renderFormFields(form.chargeType, form.formValues, idx)}
                        </div>
                    </div>
                ))}

                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <button
                        onClick={() => setChargeForms(prev => [...prev, { chargeType: '', formValues: {} }])}
                        className="add-btn"
                        title="Add Another Charge"
                    >
                        <FaPlusCircle style={{ marginRight: '8px' }} />
                        Add Another
                    </button>
                </div>


                {/* Total */}
                <div className="total-display">
                    Total Amount: ₹{totalCost.toFixed(2)}
                </div>

                {/* Actions */}
                <div className="popup-actions">
                    {/* <button onClick={() => handleSubmit(chargeForms)}>Add Charges</button> */}
                    <button onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Saving...' : 'Add Charges'}
                    </button>

                    <button onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );


};

export default AddChargeComponent;
